export const FINANCIAL_INDEX_SHORT_NAME = {
  PASS: 'PASS',
  TMO: 'TMO',
} as const;

export type FinancialIndexShortName =
  (typeof FINANCIAL_INDEX_SHORT_NAME)[keyof typeof FINANCIAL_INDEX_SHORT_NAME];
